import { j as i } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as n } from "../../../../IconBase-CxZyIWw2.js";
const r = s((l, e) => /* @__PURE__ */ i.jsx(
  n,
  {
    ref: e,
    ...l,
    image: (o) => /* @__PURE__ */ i.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ i.jsx("g", { clipPath: "url(#clip0_3410_69075)", children: /* @__PURE__ */ i.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M9.347.062A1 1 0 0 1 10 1v6h3a1 1 0 0 1 .76 1.65l-6 7A1 1 0 0 1 6 15V9H3a1 1 0 0 1-.76-1.65l6-7A1 1 0 0 1 9.348.061",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ i.jsx("defs", { children: /* @__PURE__ */ i.jsx("clipPath", { id: "clip0_3410_69075", children: /* @__PURE__ */ i.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "LightningIcon";
export {
  r as LightningIcon,
  r as default
};
//# sourceMappingURL=index.js.map
